import { render, staticRenderFns } from "./rotate-lock.vue?vue&type=template&id=706ff3b7&"
import script from "./rotate-lock.vue?vue&type=script&lang=js&"
export * from "./rotate-lock.vue?vue&type=script&lang=js&"
import style0 from "./rotate-lock.vue?vue&type=style&index=0&id=706ff3b7&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports